// extracted by mini-css-extract-plugin
export default {"buttonClass":"aYgPr","iconClass":"M2JNK"};